import axios from "axios";
import buildUrl from "build-url-ts";
import {
  AddStoryboardUsersRequest,
  StoryboardUsersSearchRequest,
  UpdateStoryboardUserAccessRequest,
} from "src/types/experiences/storyboardSettings";

const BASE_URL = process.env.REACT_APP_CLEVERSTORY_API_URL;
const apiV2 = `${BASE_URL}/api/2.0`;

export interface StoryboardUsersPage {
  records: Array<{ id: string; role: string; user: any }>;
  currentPage: number;
  totalPages: number;
  totalRecordsCount: number;
}

export const permissionsApi = {
  // GET /api/2.0/storyboards/{storyboardId}/users/search
  searchStoryboardUsers: async (payload: {
    storyboardId: string;
    request: StoryboardUsersSearchRequest & { limit?: number };
  }): Promise<StoryboardUsersPage> => {
    const url = buildUrl(
      `${apiV2}/storyboards/${payload.storyboardId}/users/search`,
    );
    const response = await axios.post(url, payload.request);
    return response.data;
  },

  // POST /api/2.0/storyboards/{storyboardId}/users
  addStoryboardUsers: async (payload: {
    storyboardId: string;
    data: AddStoryboardUsersRequest;
  }): Promise<unknown> => {
    const url = buildUrl(`${apiV2}/storyboards/${payload.storyboardId}/users`);
    const response = await axios.post(url, payload.data);
    return response.data;
  },

  // PUT /api/2.0/storyboards/user-access/{userAccessId}
  updateStoryboardUserAccess: async (payload: {
    storyboardId: string;
    data: UpdateStoryboardUserAccessRequest[];
  }): Promise<unknown> => {
    const url = buildUrl(`${apiV2}/storyboards/${payload.storyboardId}/user-access`);
    const response = await axios.put(url, payload.data);
    return response.data;
  },

  // DELETE /api/2.0/storyboards/user-access/{userAccessId}
  removeStoryboardUserAccess: async (
    userAccessId: string,
  ): Promise<unknown> => {
    const url = buildUrl(
      `${apiV2}/storyboards/user-access/${userAccessId}`,
    );
    const response = await axios.delete(url);
    return response.data;
  },
};